import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { RUN_LATEST_EXECUTION_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { run_latest_execution_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { Execution } from '@/types/runs.ts';

const useRetrieveRunLatestExecution = (runId: string): UseQueryResult<Execution, AxiosError> => {
  const automationId = useAutomationId();
  const apiClient = useApiClient();

  return useQuery({
    queryKey: RUN_LATEST_EXECUTION_KEY(automationId, runId),
    queryFn: async () => {
      const response = await apiClient.get(run_latest_execution_url(runId));
      return response.data;
    },
    enabled: !!runId,
  });
};

export default useRetrieveRunLatestExecution;
